import { useEffect, useState } from "react";
import type { ApiClient } from "../../api/client";
import type { MissingZ } from "../../api/types";

/** Every ten minutes, so the bar appears soon after 06:00 when yesterday got no Z. */
const EVERY_MS = 10 * 60_000;

/**
 * The days before today that still have no Z (Furkan, 11/10/2026): the orange bar on every till, until
 * the Z of each of those days is made. Asked again after every Z (`revision`) and every ten minutes.
 */
export function useMissingZ(api: ApiClient, revision: number): MissingZ[] {
  const [days, setDays] = useState<MissingZ[]>([]);
  useEffect(() => {
    let live = true;
    const ask = () => {
      api
        .request<{ days: MissingZ[] }>("GET", "/device/reports/missing")
        .then((answer) => {
          if (live) setDays(answer.days);
        })
        // the bar is a reminder only: a server without this answer (older) or no connection shows nothing
        .catch(() => undefined);
    };
    ask();
    const timer = setInterval(ask, EVERY_MS);
    return () => {
      live = false;
      clearInterval(timer);
    };
  }, [api, revision]);
  return days;
}
